import { HtmlParser } from '@calendly/html-parser'
import { I18n } from '@calendly/i18n'
import moment from 'moment/moment'

import { SECONDS_PER_DAY } from 'components/event_type_edit/utils/constants'
import { userDateFormat } from 'services/time_format'

import { TYPE_EXACT_STRING } from './constants'

export const emphasizeQueryInText = (result, query) => {
  const escapedQuery = query.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&')
  const queryPattern = new RegExp(escapedQuery, 'i')
  const match = result.match(queryPattern)

  if (!match) { // no overlap to emphasize
    return result
  }

  return HtmlParser(result.replace(queryPattern, `<b>${match[0]}</b>`))
}

const formatTimeRange = (startTime, endTime, timeNotation) => {
  if (timeNotation !== '12h') {
    return `${moment(startTime).format('HH:mm')}–${moment(endTime).format('HH:mm')}`
  }

  let start = moment(startTime).format('h:mm a')
  let end = moment(endTime).format('h:mm a')

  // Remove :00 when top of the hour
  start = start.replace(':00', '')
  end = end.replace(':00', '')

  // If the times are in the same am/pm, omit the first meridiem
  if (start.slice(-2) === end.slice(-2)) {
    start = start.slice(0, -3)
  }

  return `${start}–${end}`
}

export const buildDateTimeLabel = (startTime, endTime, dateNotation, timeNotation) => {
  const duration = moment(endTime).diff(moment(startTime), 'seconds')
  const allDay = duration === SECONDS_PER_DAY
  const dateMoment = allDay ? moment.utc(startTime) : moment(startTime)
  const dateLabel = userDateFormat(dateMoment, dateNotation, 'date_small')
  const timeLabel = allDay
    ? I18n.t('publisher.event_type_editor.sections.available_hours.bookable_events.all_day')
    : formatTimeRange(startTime, endTime, timeNotation)

  return `${dateLabel}, ${timeLabel}`
}

export const filterBusyTimesByQuery = (suggestions, query, type) => {
  const viableSuggestions = suggestions.filter((suggestion) => {
    const nameToLower = suggestion.name?.toLowerCase() || ''
    const queryToLower = query.toLowerCase()

    return nameToLower.includes(queryToLower)
  })

  if (type === TYPE_EXACT_STRING) {
    return viableSuggestions.filter((s) => query.toLowerCase() === s.name?.toLowerCase())
  }

  return viableSuggestions
}
